import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationStart } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import {
  UserLoginDTO,
  UserLoginReadByUserIdRequestDTO,
  UserLoginUpdateRequestDTO,
} from 'src/app/login/userlogin.interface';
import { UserLoginService } from 'src/app/login/userlogin.service';

@Component({
  selector: 'app-society-reset-password',
  templateUrl: './society-reset-password.component.html',
  styleUrls: ['./society-reset-password.component.css']
})
export class SocietyResetPasswordComponent {
  userId!: number;
  userData!: UserLoginDTO;
 
  newPassword = '';
  confirmPassword = '';
 
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private userLoginService = inject(UserLoginService);
  private toastr = inject(ToastrService);
  private routerSub!: Subscription;
 
  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.userId = Number(params.get('id'));
      if (this.userId) {
        this.getUserLogin();
      }
    });
 
    // Remove token on any navigation away (guards forced reset flow)
    this.routerSub = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        localStorage.removeItem('access_token');
      }
    });
 
    this.toastr.warning(
      'Your password has expired. Please set a new password.',
      'Password Expired'
    );
  }
 
  ngOnDestroy(): void {
    localStorage.removeItem('access_token');
    this.routerSub?.unsubscribe();
  }
 
  getUserLogin(): void {
    const data: UserLoginReadByUserIdRequestDTO = { userId: this.userId };
 
    this.userLoginService.UserLogin_ReadByUserId(data).subscribe((res) => {
      this.userData = res;
      // If account is not expired, redirect home
      if (res.status !== 'Expired') {
        this.router.navigate(['/']);
      }
    });
  }
 
  updatePassword(): void {
    if (!this.newPassword || !this.confirmPassword) return;
 
    if (this.newPassword !== this.confirmPassword) {
      this.toastr.error(
        'Your new password and confirmation do not match. Please check and try again.',
        'Password Mismatch'
      );
      return;
    }
 
    const data: UserLoginUpdateRequestDTO = {
      loginId: this.userData.loginId,
      userId: this.userData.userId,
      userName: this.userData.userName,
      userPassword: this.newPassword,
      isActive: 1,
      status: 'Active',
      actionUser: this.userData.userId.toString(),
    };
 
    this.userLoginService.UserLogin_Update(data).subscribe({
      next: () => {
        this.toastr.success(
          'Please login with your new password.',
          'Password changed successfully!'
        );
        localStorage.removeItem('access_token');
        setTimeout(() => this.router.navigate(['/login']), 2000);
      },
      error: () => {
        this.toastr.error(
          'Something went wrong while resetting your password.',
          'Error'
        );
      },
    });
  }
 
  redirectToSignUp(): void {
    localStorage.removeItem('access_token');
    this.router.navigate(['/signup']);
  }
}
